import React, {useState} from "react";
import {Button} from "../../../../../../stories/Button/Button";
import {Title} from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import {Label} from "../../../../../../stories/Label/Label";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import {Keys} from "../../../../../../utils/Enum.keys";
import {handleMUISelectEvent} from "../../../../../../utils/UtilFunctions";
import {TextField} from "@mui/material";
import Input from "../../../../../../stories/Input/Input";
import Preview from "../../../../../../images/EyeWhite.svg";
import Assign from "../../../../../../images/Assign.svg";
import Clear from "../../../../../../images/Clear.svg";
import Edit from "../../../../../../images/EditBlue.svg";
import Delete from "../../../../../../images/DeleteRed.svg";
import {Select} from "../../../../../../stories/Select/Select";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import {AntSwitch} from "../../../../../../styles/Switch";
import {stockItemInputs} from "../../../../../../utils/formTypes";
import {emptyMessage} from "../../../../../../utils/constants";
import {DataTypes, Operation} from "../../../../../../utils/Enum.types";
import MessageModal from "../../../../../../customComponents/MessageModal";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
import {LabelProps} from "../../../../../../utils/types";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

enum ComponentTypes {
  INPUT = "Input",
  SELECT = "Select",
  TEXTAREA = "TextArea",
  TOGGLE = "Toggle/Boolean",
  DATE = "Date",
  START_AND_END_DATE = "Start Date & End Date",
}

interface Item {
  id: number;
  name: string;
  type: string;
}

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
  listdata: {
    formData: stockItemInputs;
    setFormData: (value: React.SetStateAction<stockItemInputs>) => void;
    dynamicFieldData: Item[];
    setDynamicFieldData: (value: React.SetStateAction<Item[]>) => void;
  };
}

const ItemConfiguration = ({setModalFlag, listdata}: Props) => {
  const {formData, setFormData, dynamicFieldData, setDynamicFieldData} =
    listdata;
  const {Masters} = useFormJson();

  const [componentType, setSelectedComponentType] = useState("");
  const [dataType, setDataType] = useState("");
  const [index, setIndex] = useState(0);
  const [preview, setPreview] = useState(false);
  const [predefinedData, setPredefinedData] = useState(false);
  const [message, setMessage] = useState(emptyMessage);

  const [input, setInput] = useState("");
  const [editingId, setEditingId] = useState(0);

  const createItem = () => {
    if (input.trim() && dataType) {
      const newItem = {
        id: dynamicFieldData.length + 1,
        name: input,
        type: dataType,
      };
      setDynamicFieldData([...dynamicFieldData, newItem]);

      setFormData({
        ...formData,
        [`noOfAdditionalProperties`]: dynamicFieldData.length + 1,
        [`AdditionalPropertyDesc${dynamicFieldData.length + 1}`]: input,
        [`AdditionalPropertyDatatype${dynamicFieldData.length + 1}`]: dataType,
      });
      handleClear();
      setMessage({
        message: "Added Dynamic Field Successfully",
        flag: true,
        operation: Operation.CREATE,
      });
    } else {
      setMessage({
        flag: true,
        message: "Required all field",
        operation: Operation.NONE,
      });
    }
  };

  const updateItem = () => {
    if (editingId) {
      setDynamicFieldData(
        dynamicFieldData.map((item) =>
          item.id === editingId
            ? {
                ...item,
                name: input ? input : item.name,
                type: dataType ? dataType : item.type,
              }
            : item
        )
      );

      setFormData({
        ...formData,
        [`AdditionalPropertyDesc${index + 1}`]: input,
        [`AdditionalPropertyDatatype${index + 1}`]: dataType,
      });

      handleClear();
      setMessage({
        message: "Update Dynamic Field Successfully",
        flag: true,
        operation: Operation.UPDATE,
      });
    }
  };

  const HandleDelete = (id: number) => {
    setDynamicFieldData(dynamicFieldData.filter((item, index) => index !== id));
    const updatedFormData = dynamicFieldData.filter((item) => index !== id);

    const updatedFormDataObj = updatedFormData.reduce((acc, item, index) => {
      acc[`AdditionalPropertyDesc${index + 1}`] = item.name;
      acc[`AdditionalPropertyDatatype${index + 1}`] = item.type;
      return acc;
    }, {} as stockItemInputs);

    setFormData({
      ...formData,
      ...updatedFormDataObj,
      [`noOfAdditionalProperties`]: dynamicFieldData.length - 1,
    });
    handleClear();
    setMessage({
      message: "Delete Dynamic Field Successfully",
      flag: true,
      operation: Operation.DELETE,
    });
  };

  const handleClear = () => {
    setInput("");
    setEditingId(0);
    setDataType("");
  };

  const handleSubmit = () => {
    const updatedFormData = {...formData};

    dynamicFieldData.forEach((item, index) => {
      updatedFormData[`AdditionalPropertyDesc${index + 1}`] = item.name;
      updatedFormData[`AdditionalPropertyDatatype${index + 1}`] = item.type;
    });

    setFormData(updatedFormData);
    setModalFlag(false);
  };

  const handleClose = () => {
    setMessage({
      message: "",
      flag: false,
      operation: Operation.NONE,
    });
  };
  const {itemLabel} = useLabels();
  return (
    <>
      <div className="asset-config">
        <div className="asset-config__title">
          <Title>
            {" "}
            {itemLabel} / {itemLabel} Configurations
          </Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        {/* use the below div for forms */}
        <div className="asset-config__form">
          <div className="asset-config__form--details row g-0">
            <div className="asset-config__form--details--left col">
              <Title variant="subtitle1">Add New Dynamic Field </Title>
              <div className="asset-config__form--details--block">
                {Masters.ItemConfigurations.map(
                  (label: LabelProps, index: React.Key) => {
                    if (label.inputName === "AdditionalPropertyDatatype") {
                      return (
                        <div className="label-grid" key={index}>
                          <Label>{label.labelName}</Label>
                          <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={Object.values(DataTypes)}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                e.preventDefault();
                                handleMUISelectEvent(e);
                              }
                            }}
                            value={dataType}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                setDataType(newValue as string);
                              }
                            }}
                            openOnFocus
                            forcePopupIcon
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                className={formClasses.formControlRoot}
                              />
                            )}
                          />
                        </div>
                      );
                    } else
                      return (
                        <div className="label-grid">
                          <Label>{label.labelName}</Label>
                          <Input
                            onChange={(e) => {
                              setInput(e.target.value);
                            }}
                            value={input}
                          />
                        </div>
                      );
                  }
                )}
                {componentType && (
                  <>
                    {componentType === ComponentTypes.SELECT && (
                      <>
                        <button
                          className="asset-config__form--assign-button"
                          onClick={() => setPredefinedData(!predefinedData)}
                        >
                          Enter Predefined Data <img src={Assign} alt="" />
                        </button>
                      </>
                    )}
                    <>
                      {!preview ? (
                        <button
                          className="asset-config__form--preview-button"
                          onClick={() => setPreview(!preview)}
                        >
                          Preview <img src={Preview} alt="" />
                        </button>
                      ) : (
                        <button
                          className="asset-config__form--clear-button"
                          onClick={() => setPreview(!preview)}
                        >
                          Clear <img src={Clear} alt="" />
                        </button>
                      )}
                    </>
                  </>
                )}

                {preview && (
                  <div className="asset-config__form--preview">
                    <b>Preview</b>
                    <>
                      {componentType === ComponentTypes.INPUT &&
                      dataType === DataTypes.TEXT ? (
                        <div className="label-grid">
                          <Label>Item 1</Label>
                          <Input type="text" value="Text" disabled />
                        </div>
                      ) : componentType === ComponentTypes.INPUT &&
                        dataType === DataTypes.NUMBER ? (
                        <div className="label-grid">
                          <Label>Item 1</Label>
                          <Input type="number" value="1" disabled />
                        </div>
                      ) : componentType ===
                        ComponentTypes.START_AND_END_DATE ? (
                        <div className="label-grid">
                          <Label>Start Date</Label>
                          <Input type="date" value="1" disabled />
                          <Label>End Date</Label>
                          <Input type="date" value="1" disabled />
                        </div>
                      ) : componentType === ComponentTypes.TOGGLE ? (
                        <div className="label-grid">
                          <Label>Item 1</Label>
                          <AntSwitch disabled />
                        </div>
                      ) : componentType === ComponentTypes.DATE ? (
                        <div className="label-grid">
                          <Label>Item 1</Label>
                          <Input type="date" />
                        </div>
                      ) : componentType === ComponentTypes.INPUT &&
                        dataType === DataTypes.FLOAT ? (
                        <div className="label-grid">
                          <Label>Item 1</Label>

                          <Input
                            type="number"
                            pattern="0.01"
                            value="0.01"
                            disabled
                          />
                        </div>
                      ) : componentType === ComponentTypes.SELECT ? (
                        <div className="label-grid">
                          <Label>Item 1</Label>

                          <Select disabled>
                            <option>Select</option>
                          </Select>
                        </div>
                      ) : componentType === ComponentTypes.TEXTAREA ? (
                        <div className="label-grid">
                          <Label>Item 1</Label>
                          <TextArea disabled rows={2} />
                        </div>
                      ) : (
                        <div className="label-grid">
                          <Label>Item 1</Label>

                          <Input
                            type="text"
                            value="Text"
                            pattern="[A-Za-z0-9]*"
                            disabled
                          />
                        </div>
                      )}
                    </>
                  </div>
                )}
              </div>
            </div>
            <div className="asset-config__form--details--right col">
              <Title variant="subtitle1">List of Parameter / Fields </Title>
              <div className="asset-config__form--details--block">
                <div className="asset-config__form--details--block--dynamic">
                  <b className="asset-config__form--details--block--header">
                    Dynamic Parameter
                  </b>

                  <ul>
                    {dynamicFieldData ? (
                      dynamicFieldData.map((res, index) => {
                        return (
                          <li
                            key={index}
                            className="asset-config__form--details--block--dynamic--li"
                          >
                            <b>{res.name}</b>
                            <div>
                              <span>{res.type}</span>{" "}
                              <img
                                src={Edit}
                                onClick={() => {
                                  setIndex(index);
                                  setEditingId(res.id as number);
                                  setInput(res.name);
                                  setDataType(res.type);
                                }}
                                alt=""
                              />
                              <img
                                src={Delete}
                                onClick={() => {
                                  HandleDelete(index);
                                }}
                                alt=""
                              />
                            </div>
                          </li>
                        );
                      })
                    ) : (
                      <b className="nodata">No Data Available to Display</b>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-0">
            <div className="col">
              <Button
                onClick={() => {
                  if (editingId) {
                    updateItem();
                  } else {
                    createItem();
                  }
                }}
                disabled={dynamicFieldData.length >= 10 ? true : false}
              >
                {editingId ? "Update Dynamic Field" : "Add Dynamic Field"}
              </Button>
              <Button mode="clear" onClick={handleClear} />
              {/* <Button mode="cancel" onClick={() => setModalFlag(false)} /> */}
            </div>
            <div className="col flex-end">
              <div className="asset-config__form--legend">
                <span className="asset-config__form--legend--dynamic"></span>
                <span> &rarr;</span>
                <span>Dynamic Parameters</span>
              </div>
              <div className="asset-config__form--legend">
                <span className="asset-config__form--legend--default"></span>
                <span> &rarr;</span>
                <span>Default Parameters</span>
              </div>
            </div>
          </div>
        </div>

        <MessageModal
          handleClose={handleClose}
          modalFlag={message.flag}
          operation={message.operation}
          value={message.message}
        />
      </div>
    </>
  );
};

export default ItemConfiguration;
